module.exports = __webpack_public_path__ + "static/img/team1-02.8d57340.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/estate/team/team1-02.jpg
// module id = +YdI
// module chunks = 1